var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAddonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 301,
    viewBox: "0 0 406 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.025 274.648H338.18V274.851H365.025V274.648Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.817 276.844H261.773V277.046H268.817V276.844Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.359 267.117H321.805V267.32H337.359V267.117Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8823 268.484H42.875V268.687H77.8823V268.484Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2323 268.484H85.1016V268.687H90.2323V268.484Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.853 271.906H106.922V272.109H182.853V271.906Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.98 229.503H37.4641C36.2381 229.503 35.0621 229.017 34.1944 228.151C33.3266 227.284 32.8381 226.109 32.8359 224.883V4.87008C32.8381 3.64402 33.3266 2.4689 34.1944 1.6027C35.0621 0.736497 36.2381 0.249998 37.4641 0.25H193.98C195.206 0.249998 196.382 0.736497 197.249 1.6027C198.117 2.4689 198.606 3.64402 198.608 4.87008V224.916C198.597 226.136 198.105 227.303 197.238 228.162C196.371 229.021 195.2 229.503 193.98 229.503ZM37.4641 0.452635C36.2918 0.452633 35.1674 0.917784 34.3377 1.74598C33.5079 2.57418 33.0407 3.69776 33.0386 4.87008V224.916C33.0407 226.088 33.5079 227.212 34.3377 228.04C35.1674 228.868 36.2918 229.333 37.4641 229.333H193.98C195.152 229.333 196.276 228.868 197.106 228.04C197.936 227.212 198.403 226.088 198.405 224.916V4.87008C198.403 3.69776 197.936 2.57418 197.106 1.74598C196.276 0.917784 195.152 0.452633 193.98 0.452635H37.4641Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3 229.503H212.784C211.558 229.503 210.382 229.017 209.515 228.151C208.647 227.284 208.158 226.109 208.156 224.883V4.87008C208.158 3.64402 208.647 2.4689 209.515 1.6027C210.382 0.736497 211.558 0.249998 212.784 0.25H369.3C370.526 0.249998 371.702 0.736497 372.57 1.6027C373.437 2.4689 373.926 3.64402 373.928 4.87008V224.916C373.917 226.136 373.425 227.303 372.558 228.162C371.691 229.021 370.52 229.503 369.3 229.503ZM212.784 0.452635C211.612 0.452633 210.488 0.917784 209.658 1.74598C208.828 2.57418 208.361 3.69776 208.359 4.87008V224.916C208.361 226.088 208.828 227.212 209.658 228.04C210.488 228.868 211.612 229.333 212.784 229.333H369.3C370.472 229.333 371.597 228.868 372.426 228.04C373.256 227.212 373.723 226.088 373.725 224.916V4.87008C373.723 3.69776 373.256 2.57418 372.426 1.74598C371.597 0.917784 370.472 0.452633 369.3 0.452635H212.784Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.63 265.648H0.359375V265.851H405.63V265.648Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.639 146.273H182.586V244.381H234.639V146.273Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.578 133.688V146.267H196.688H220.534H224.643V133.688H192.578Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.577 149.602H185.914V156.264H192.577V149.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.491 149.602H198.828V156.264H205.491V149.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.389 149.602H211.727V156.264H218.389V149.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.311 149.602H224.648V156.264H231.311V149.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.577 161.711H185.914V168.374H192.577V161.711Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.491 161.711H198.828V168.374H205.491V161.711Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.389 161.711H211.727V168.374H218.389V161.711Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.311 161.711H224.648V168.374H231.311V161.711Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.577 173.812H185.914V180.475H192.577V173.812Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.491 173.812H198.828V180.475H205.491V173.812Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.389 173.812H211.727V180.475H218.389V173.812Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.491 139.133H198.828V145.795H205.491V139.133Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.389 139.133H211.727V145.795H218.389V139.133Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.311 173.812H224.648V180.475H231.311V173.812Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.577 185.922H185.914V192.584H192.577V185.922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.491 185.922H198.828V192.584H205.491V185.922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.389 185.922H211.727V192.584H218.389V185.922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.311 185.922H224.648V192.584H231.311V185.922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.577 198.031H185.914V204.694H192.577V198.031Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.491 198.031H198.828V204.694H205.491V198.031Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.389 198.031H211.727V204.694H218.389V198.031Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.311 198.031H224.648V204.694H231.311V198.031Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.577 210.141H185.914V216.803H192.577V210.141Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.491 210.141H198.828V216.803H205.491V210.141Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.389 210.141H211.727V216.803H218.389V210.141Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.311 210.141H224.648V216.803H231.311V210.141Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.577 222.25H185.914V228.913H192.577V222.25Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.491 222.25H198.828V228.913H205.491V222.25Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.389 222.25H211.727V228.913H218.389V222.25Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.311 222.25H224.648V228.913H231.311V222.25Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.502 146.336H235.703V144.974H181.502V146.336Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.033 129.281H122.156V244.378H184.033V129.281Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.039 114.328V129.283H138.919H167.271H172.151V114.328H134.039Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.875 129.359H185.305V127.746L120.875 127.746V129.359Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.428 114.328H173.773V112.715H132.428V114.328Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.135 129.281H109.258V244.378H171.135V129.281Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.141 114.328V129.283H126.02H154.373H159.252V114.328H121.141Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.138 133.234H113.219V141.153H121.138V133.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.481 133.234H128.562V141.153H136.481V133.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.825 133.234H143.906V141.153H151.825V133.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.169 133.234H159.25V141.153H167.169V133.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.138 147.633H113.219V155.552H121.138V147.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.481 147.633H128.562V155.552H136.481V147.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.825 147.633H143.906V155.552H151.825V147.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.169 147.633H159.25V155.552H167.169V147.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.138 162.023H113.219V169.942H121.138V162.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.481 162.023H128.562V169.942H136.481V162.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.825 162.023H143.906V169.942H151.825V162.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.481 120.797H128.562V128.716H136.481V120.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.825 120.797H143.906V128.716H151.825V120.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.169 162.023H159.25V169.942H167.169V162.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.138 176.422H113.219V184.341H121.138V176.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.481 176.422H128.562V184.341H136.481V176.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.825 176.422H143.906V184.341H151.825V176.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.169 176.422H159.25V184.341H167.169V176.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.138 190.812H113.219V198.732H121.138V190.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.481 190.812H128.562V198.732H136.481V190.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.825 190.812H143.906V198.732H151.825V190.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.169 190.812H159.25V198.732H167.169V190.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.138 205.203H113.219V213.122H121.138V205.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.481 205.203H128.562V213.122H136.481V205.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.825 205.203H143.906V213.122H151.825V205.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.169 205.203H159.25V213.122H167.169V205.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.138 219.594H113.219V227.513H121.138V219.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.481 219.594H128.562V227.513H136.481V219.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.825 219.594H143.906V227.513H151.825V219.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.169 219.594H159.25V227.513H167.169V219.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.984 129.359H172.414V127.746L107.984 127.746V129.359Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.521 114.328H160.867V112.715H119.521V114.328Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.111 181.411H43.4766V243.912H98.7473V181.411V157.281L78.111 181.411Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.068 157.281H98.75V243.912H109.068V157.281Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2895 192.438H46.0625V200.664H54.2895V192.438Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.2876 192.438H46.9766V200.664H54.2876V192.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2895 206.281H46.0625V214.508H54.2895V206.281Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.2876 206.281H46.9766V214.508H54.2876V206.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2895 220.117H46.0625V228.344H54.2895V220.117Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.2876 220.117H46.9766V228.344H54.2876V220.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.2036 220.117H46.9766V228.344H55.2036V220.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1489 192.438H59.9219V200.664H68.1489V192.438Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.1548 192.438H60.8438V200.664H68.1548V192.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1489 206.281H59.9219V214.508H68.1489V206.281Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.1548 206.281H60.8438V214.508H68.1548V206.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1489 220.117H59.9219V228.344H68.1489V220.117Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.1548 220.117H60.8438V228.344H68.1548V220.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.0707 220.117H60.8438V228.344H69.0707V220.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.016 192.438H73.7891V200.664H82.016V192.438Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.022 192.438H74.7109V200.664H82.022V192.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.016 206.281H73.7891V214.508H82.016V206.281Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.022 206.281H74.7109V214.508H82.022V206.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.016 220.117H73.7891V228.344H82.016V220.117Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.022 220.117H74.7109V228.344H82.022V220.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.9379 220.117H74.7109V228.344H82.9379V220.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8832 192.438H87.6562V200.664H95.8832V192.438Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M95.8814 192.438H88.5703V200.664H95.8814V192.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8832 206.281H87.6562V214.508H95.8832V206.281Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M95.8814 206.281H88.5703V214.508H95.8814V206.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8832 220.117H87.6562V228.344H95.8832V220.117Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M95.8814 220.117H88.5703V228.344H95.8814V220.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.8051 220.117H88.5781V228.344H96.8051V220.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.086 46.1616L300.67 45.9185C301.436 45.9085 302.188 46.1227 302.834 46.5345C309.659 53.0188 317.521 49.2741 321.015 47.0046C322.344 46.1343 323.892 45.6567 325.481 45.6267L349.53 45.3511C358.559 45.2457 360.594 32.5851 352.034 29.7238L351.71 29.578C361.047 21.6184 340.168 5.26173 317.959 28.4837C319.629 20.816 299.681 23.8069 293.692 34.3115C291.438 27.5192 272.528 39.6449 279.086 46.1616Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.736 78.073H191.578C196.166 78.073 197.252 71.6454 192.94 70.1378L192.77 70.0811C197.568 66.0851 187.047 57.6555 175.61 69.3273C176.502 65.4367 166.338 66.8389 163.234 72.148C162.131 68.6626 152.437 74.7174 155.736 78.073Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4066 47.2872H116.294C124.092 47.2872 125.972 36.3692 118.604 33.7998L118.321 33.7106C126.475 26.9183 108.594 12.6366 89.1413 32.4219C90.657 25.816 73.3925 28.2071 68.1159 37.2203C66.2678 31.3033 49.8058 41.581 55.4066 47.2872Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.092 170.945H171.469V250.273H223.092V170.945Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M214.379 170.938H171.469V250.273H214.379V170.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M223.096 170.938H214.375V250.273H223.096V170.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51 174.969H175.148V184.33H184.51V174.969Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.596 174.969H188.234V184.33H197.596V174.969Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.682 174.969H201.32V184.33H210.682V174.969Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51 187.172H175.148V196.534H184.51V187.172Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.596 187.172H188.234V196.534H197.596V187.172Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.682 187.172H201.32V196.534H210.682V187.172Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51 199.375H175.148V208.737H184.51V199.375Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.596 199.375H188.234V208.737H197.596V199.375Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.682 199.375H201.32V208.737H210.682V199.375Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51 211.57H175.148V220.932H184.51V211.57Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.596 211.57H188.234V220.932H197.596V211.57Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.682 211.57H201.32V220.932H210.682V211.57Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51 223.766H175.148V233.127H184.51V223.766Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.596 223.766H188.234V233.127H197.596V223.766Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.682 223.766H201.32V233.127H210.682V223.766Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51 239.211H175.148V250.275H184.51V239.211Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.596 235.969H188.234V250.275H197.596V235.969Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.682 239.211H201.32V250.275H210.682V239.211Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.514 174.969H175.922V184.33H184.514V174.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.607 174.969H189.016V184.33H197.607V174.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.693 174.969H202.102V184.33H210.693V174.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.514 187.172H175.922V196.534H184.514V187.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.607 187.172H189.016V196.534H197.607V187.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.693 187.172H202.102V196.534H210.693V187.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.514 199.375H175.922V208.737H184.514V199.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.607 199.375H189.016V208.737H197.607V199.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.693 199.375H202.102V208.737H210.693V199.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.514 211.57H175.922V220.932H184.514V211.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.607 211.57H189.016V220.932H197.607V211.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.693 211.57H202.102V220.932H210.693V211.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.514 223.766H175.922V233.127H184.514V223.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.607 223.766H189.016V233.127H197.607V223.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.693 223.766H202.102V233.127H210.693V223.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.514 239.211H175.922V250.275H184.514V239.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.607 235.969H189.016V250.275H197.607V235.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.693 239.211H202.102V250.275H210.693V239.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.328 167.508H231.939L230.051 171.536H170.225L168.328 167.508Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M215.314 167.508H231.938L230.05 171.536H214.406L215.314 167.508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.047 123.492H305.945V250.277H358.047V123.492Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M345.581 123.492H305.945V250.277H345.581V123.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.489 119.734H303.5V123.779H360.489V119.734Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M360.491 119.734H345.594V123.779H360.491V119.734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M358.06 123.781H345.594V250.274H358.06V123.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.001 128.547H311.266V138.752H318.001V128.547Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M318.001 129.219H311.266V138.743H318.001V129.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23 128.547H311.266V138.752H312.23V128.547Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.611 128.547H321.875V138.752H328.611V128.547Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.611 129.219H321.875V138.743H328.611V129.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84 128.547H321.875V138.752H322.84V128.547Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22 128.547H332.484V138.752H339.22V128.547Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.22 129.219H332.484V138.743H339.22V129.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.449 128.547H332.484V138.752H333.449V128.547Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.001 143.914H311.266V154.119H318.001V143.914Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M318.001 144.586H311.266V154.11H318.001V144.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23 143.914H311.266V154.119H312.23V143.914Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.611 143.914H321.875V154.119H328.611V143.914Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.611 144.586H321.875V154.11H328.611V144.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84 143.914H321.875V154.119H322.84V143.914Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22 143.914H332.484V154.119H339.22V143.914Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.22 144.586H332.484V154.11H339.22V144.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.449 143.914H332.484V154.119H333.449V143.914Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.001 159.273H311.266V169.478H318.001V159.273Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M318.001 159.953H311.266V169.477H318.001V159.953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23 159.273H311.266V169.478H312.23V159.273Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.611 159.273H321.875V169.478H328.611V159.273Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.611 159.953H321.875V169.477H328.611V159.953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84 159.273H321.875V169.478H322.84V159.273Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22 159.273H332.484V169.478H339.22V159.273Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.22 159.953H332.484V169.477H339.22V159.953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.449 159.273H332.484V169.478H333.449V159.273Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.001 174.641H311.266V184.845H318.001V174.641Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M318.001 175.32H311.266V184.844H318.001V175.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23 174.641H311.266V184.845H312.23V174.641Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.611 174.641H321.875V184.845H328.611V174.641Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.611 175.32H321.875V184.844H328.611V175.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84 174.641H321.875V184.845H322.84V174.641Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22 174.641H332.484V184.845H339.22V174.641Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.22 175.32H332.484V184.844H339.22V175.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.449 174.641H332.484V184.845H333.449V174.641Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.001 190.016H311.266V200.22H318.001V190.016Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M318.001 190.68H311.266V200.204H318.001V190.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23 190.016H311.266V200.22H312.23V190.016Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.611 190.016H321.875V200.22H328.611V190.016Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.611 190.68H321.875V200.204H328.611V190.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84 190.016H321.875V200.22H322.84V190.016Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22 190.016H332.484V200.22H339.22V190.016Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.22 190.68H332.484V200.204H339.22V190.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.449 190.016H332.484V200.22H333.449V190.016Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.001 205.367H311.266V215.572H318.001V205.367Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M318.001 206.047H311.266V215.571H318.001V206.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23 205.367H311.266V215.572H312.23V205.367Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.611 205.367H321.875V215.572H328.611V205.367Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.611 206.047H321.875V215.571H328.611V206.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84 205.367H321.875V215.572H322.84V205.367Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22 205.367H332.484V215.572H339.22V205.367Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.22 206.047H332.484V215.571H339.22V206.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.449 205.367H332.484V215.572H333.449V205.367Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.001 220.734H311.266V230.939H318.001V220.734Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M318.001 221.422H311.266V230.946H318.001V221.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23 220.734H311.266V230.939H312.23V220.734Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.611 220.734H321.875V230.939H328.611V220.734Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.611 221.422H321.875V230.946H328.611V221.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84 220.734H321.875V230.939H322.84V220.734Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22 220.734H332.484V230.939H339.22V220.734Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.22 221.422H332.484V230.946H339.22V221.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.449 220.734H332.484V230.939H333.449V220.734Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.001 236.102H311.266V246.306H318.001V236.102Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M318.001 236.781H311.266V246.305H318.001V236.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23 236.102H311.266V246.306H312.23V236.102Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.611 236.102H321.875V246.306H328.611V236.102Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.611 236.781H321.875V246.305H328.611V236.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84 236.102H321.875V246.306H322.84V236.102Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22 236.102H332.484V246.306H339.22V236.102Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.22 236.781H332.484V246.305H339.22V236.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.449 236.102H332.484V246.306H333.449V236.102Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.222 51.5938H247.062V76.5584H248.222V51.5938Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.417 51.5938H272.258V76.5584H273.417V51.5938Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.212 62.9688H256.055V83.6619H295.212V62.9688Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M295.212 62.9688H256.055V83.6619H295.212V62.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.563 62.9688H233.406V83.6619H272.563V62.9688Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M272.563 62.9688H233.406V83.6619H272.563V62.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.688 94.7578H227.727V102.863H229.688V94.7578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.688 115.68H227.727V123.785H229.688V115.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.688 129.852H227.727V137.957H229.688V129.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.688 144.023H227.727V152.129H229.688V144.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.688 158.195H227.727V166.301H229.688V158.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.688 172.367H227.727V180.473H229.688V172.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.688 187.984H227.727V196.09H229.688V187.984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.688 203.602H227.727V211.707H229.688V203.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.688 219.211H227.727V227.316H229.688V219.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.688 234.836H227.727V242.941H229.688V234.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.235 83.9609H245.047V250.276H306.235V83.9609Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.571 83.9609H222.383V250.276H283.571V83.9609Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M306.225 86.2422H283.578V250.279H306.225V86.2422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M283.571 83.9609H222.383V250.276H283.571V83.9609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.779 91.2266H270.273V246.299H277.779V91.2266Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.31 91.2266H255.805V246.299H263.31V91.2266Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.857 91.2266H241.352V246.299H248.857V91.2266Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.388 91.2266H226.883V246.299H234.388V91.2266Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.779 93.1875H270.273V246.299H277.779V93.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M263.31 93.1875H255.805V246.299H263.31V93.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.857 93.1875H241.352V246.299H248.857V93.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M234.388 93.1875H226.883V246.299H234.388V93.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.614 91.2266H300.469V246.299H303.614V91.2266Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.551 91.2266H294.406V246.299H297.551V91.2266Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.481 91.2266H288.336V246.299H291.481V91.2266Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M303.621 93.1875H300.477V246.299H303.621V93.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M297.559 93.1875H294.414V246.299H297.559V93.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M291.489 93.1875H288.344V246.299H291.489V93.1875Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.92 79.2344H283.578V82.3549H304.92V79.2344Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.92 78.4766H222.383V82.359H304.92V78.4766Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.814 82.3594H220.656V86.2419H307.814V82.3594Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.814 75.3516H220.656V79.2341H307.814V75.3516Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M307.814 82.3594H220.656V86.2419H307.814V82.3594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M307.814 75.3516H220.656V79.2341H307.814V75.3516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M307.813 82.3594H283.578V86.2419H307.813V82.3594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M307.813 75.3516H283.578V79.2341H307.813V75.3516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M257.682 62.9688H248.328V72.3224H257.682V62.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.941 137.956C145.997 128.586 136.044 125.385 128.741 128.878C127.691 129.381 126.504 129.526 125.364 129.29C124.224 129.054 123.192 128.451 122.427 127.573C113.592 118.001 99.2697 116.866 93.3284 125.895C92.656 126.918 92.0859 128.004 91.6263 129.137C90.8969 130.963 89.6835 132.555 88.1166 133.741C87.0523 134.532 86.1381 135.506 85.4175 136.619C83.4894 139.815 82.5949 143.529 82.8562 147.253C82.9008 147.809 82.7856 148.366 82.5242 148.858C82.2629 149.351 81.8662 149.759 81.381 150.033C79.7268 150.9 78.3293 152.185 77.3283 153.762C72.5137 161.057 74.6373 174.106 82.07 182.868C88.6921 190.674 97.2919 192.465 102.488 187.586C102.699 187.383 102.981 187.269 103.274 187.269C103.567 187.269 103.849 187.383 104.06 187.586C107.805 190.949 112.165 190.974 114.411 187.326C114.497 187.167 114.619 187.031 114.768 186.928C114.917 186.825 115.088 186.759 115.267 186.734C115.446 186.71 115.628 186.728 115.799 186.787C115.97 186.846 116.125 186.945 116.25 187.075C120.109 190.941 124.769 191.128 127.144 187.326C127.572 186.618 127.899 185.855 128.117 185.057C128.15 184.887 128.219 184.727 128.32 184.587C128.421 184.447 128.551 184.33 128.701 184.244C128.851 184.159 129.017 184.107 129.189 184.092C129.362 184.077 129.535 184.099 129.697 184.157C132.218 185.17 134.69 184.732 136.376 182.739C136.544 182.531 136.78 182.392 137.042 182.346C137.305 182.3 137.575 182.35 137.803 182.487C146.451 187.659 155.57 186.662 160.644 178.953C167.428 168.635 164.478 150.293 153.941 137.956Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M153.941 137.956C145.997 128.586 136.044 125.385 128.741 128.878C127.691 129.381 126.504 129.526 125.364 129.29C124.224 129.054 123.192 128.451 122.427 127.573C113.592 118.001 99.2697 116.866 93.3284 125.895C92.656 126.918 92.0859 128.004 91.6263 129.137C90.8969 130.963 89.6835 132.555 88.1166 133.741C87.0523 134.532 86.1381 135.506 85.4175 136.619C83.4894 139.815 82.5949 143.529 82.8562 147.253C82.9008 147.809 82.7856 148.366 82.5242 148.858C82.2629 149.351 81.8662 149.759 81.381 150.033C79.7268 150.9 78.3293 152.185 77.3283 153.762C72.5137 161.057 74.6373 174.106 82.07 182.868C88.6921 190.674 97.2919 192.465 102.488 187.586C102.699 187.383 102.981 187.269 103.274 187.269C103.567 187.269 103.849 187.383 104.06 187.586C107.805 190.949 112.165 190.974 114.411 187.326C114.497 187.167 114.619 187.031 114.768 186.928C114.917 186.825 115.088 186.759 115.267 186.734C115.446 186.71 115.628 186.728 115.799 186.787C115.97 186.846 116.125 186.945 116.25 187.075C120.109 190.941 124.769 191.128 127.144 187.326C127.572 186.618 127.899 185.855 128.117 185.057C128.15 184.887 128.219 184.727 128.32 184.587C128.421 184.447 128.551 184.33 128.701 184.244C128.851 184.159 129.017 184.107 129.189 184.092C129.362 184.077 129.535 184.099 129.697 184.157C132.218 185.17 134.69 184.732 136.376 182.739C136.544 182.531 136.78 182.392 137.042 182.346C137.305 182.3 137.575 182.35 137.803 182.487C146.451 187.659 155.57 186.662 160.644 178.953C167.428 168.635 164.478 150.293 153.941 137.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.069 191.858L108.599 199.226C108 209.625 107.505 233.577 107.505 233.577L104.83 250.323L128.425 250.549C128.425 250.549 127.355 236.406 127.355 235.644C127.355 234.882 122.792 207.785 122.792 207.785L121.171 192.612L133.329 188.697L135.55 181.937L144.466 176.604L148.835 169.528L147.149 169.098L142.285 175.631L136.652 176.92L139.084 170.906H136.401L129.698 184.847L121.057 186.711L122.184 167.137C115.278 170.541 113.065 164.867 113.065 164.867C113.065 164.867 110.212 191.218 109.207 194.217L104.757 191.858L99.8941 183.818H97.8516L101.069 191.858Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5352 224.555H65.3438V239.874H66.5352V224.555Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.5352 224.555H65.3438V239.874H66.5352V224.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2384 224.555H90.0469V239.874H91.2384V224.555Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.2384 224.555H90.0469V239.874H91.2384V224.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5863 238.383H64.0391V240.247H92.5863V238.383Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.5863 238.383H64.0391V240.247H92.5863V238.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9337 240.188H64.7422V250.554H65.9337V240.188Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.9337 240.188H64.7422V250.554H65.9337V240.188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9962 240.188H90.8047V250.554H91.9962V240.188Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.9962 240.188H90.8047V250.554H91.9962V240.188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5863 225.242H64.0391V234.255H92.5863V225.242Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.5863 225.242H64.0391V234.255H92.5863V225.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5281 239.875H64.0781V242.777H92.5281V239.875Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.5281 239.875H64.0781V242.777H92.5281V239.875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0821 235.75H62.8906V250.542H64.0821V235.75Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5437 234.266H62.4688V236.341H64.5437V234.266Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.5437 234.266H62.4688V236.341H64.5437V234.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1601 234.266H64.5391V236.341H66.1601V234.266Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5429 250.539H93.7344V235.747H92.5429V250.539Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0894 236.328H94.1562V234.253H92.0894V236.328Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.0894 236.328H94.1562V234.253H92.0894V236.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0742 234.266H90.4531V236.341H92.0742V234.266Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M66.1601 234.266H64.5391V236.341H66.1601V234.266Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.0742 234.266H90.4531V236.341H92.0742V234.266Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0378 121.125H62.9922V125.696H64.0378V121.125Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1245 119.219C64.6402 120.029 54.8327 122.202 47.1406 126.246V127.778C54.5876 123.775 62.7574 121.295 71.1732 120.483L71.1245 119.219Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3792 121.494C81.9633 121.135 81.4961 120.84 80.9932 120.619C79.8827 120.141 73.1634 121.146 70.8614 121.511V120.53L70.8047 119.257C72.369 119.095 73.7713 118.982 74.9547 118.909C76.8919 118.803 78.3265 118.739 79.3883 118.706C79.7688 118.689 80.1488 118.747 80.5063 118.879C80.8637 119.01 81.1913 119.212 81.4699 119.472C81.7485 119.731 81.9724 120.044 82.1285 120.391C82.2847 120.739 82.3699 121.114 82.3792 121.494Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1387 137.027C46.9237 137.027 46.7175 136.942 46.5655 136.79C46.4135 136.638 46.3281 136.432 46.3281 136.217C46.3281 135.803 46.3281 134.944 50.6402 131.046C51.2469 130.486 51.8915 129.969 52.5693 129.497C56.5352 126.965 60.985 125.287 65.6352 124.569C65.8502 124.541 66.0674 124.6 66.2392 124.732C66.411 124.864 66.5232 125.06 66.5511 125.275C66.5791 125.489 66.5205 125.707 66.3882 125.878C66.256 126.05 66.0609 126.162 65.8459 126.19C65.7811 126.19 58.8834 127.163 53.4852 130.851C52.8659 131.281 52.2781 131.755 51.7263 132.269C48.9219 134.806 48.0303 135.998 47.9411 136.322C47.9156 136.517 47.8201 136.696 47.6725 136.826C47.5249 136.955 47.3352 137.027 47.1387 137.027Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0623 126.024H47.6834C47.735 126.024 47.7845 126.045 47.8209 126.081C47.8574 126.118 47.8779 126.167 47.8779 126.219V250.612H45.8516V126.202C45.8536 126.177 45.8607 126.152 45.8724 126.129C45.8841 126.106 45.9002 126.086 45.9198 126.069C45.9394 126.053 45.9621 126.04 45.9865 126.033C46.011 126.025 46.0367 126.022 46.0623 126.024Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3922 121.583V121.648L72.9818 122.532L70.8906 121.648V121.51C73.1926 121.146 79.9119 120.141 81.0224 120.619C81.5168 120.842 81.9756 121.137 82.3841 121.494C82.3912 121.523 82.394 121.553 82.3922 121.583Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M82.3922 121.583V121.648L72.9818 122.532L70.8906 121.648V121.51C73.1926 121.146 79.9119 120.141 81.0224 120.619C81.5168 120.842 81.9756 121.137 82.3841 121.494C82.3912 121.523 82.394 121.553 82.3922 121.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.478 179.352H324.577C324.644 179.352 324.708 179.378 324.755 179.425C324.802 179.472 324.828 179.536 324.828 179.603V256.92H322.227V179.603C322.227 179.536 322.253 179.472 322.3 179.425C322.347 179.378 322.411 179.352 322.478 179.352Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.9 181.453H311.057C309.472 181.453 308.188 182.738 308.188 184.322V188.951C308.188 190.535 309.472 191.82 311.057 191.82H335.9C337.485 191.82 338.769 190.535 338.769 188.951V184.322C338.769 182.738 337.485 181.453 335.9 181.453Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M335.9 181.453H311.057C309.472 181.453 308.188 182.738 308.188 184.322V188.951C308.188 190.535 309.472 191.82 311.057 191.82H335.9C337.485 191.82 338.769 190.535 338.769 188.951V184.322C338.769 182.738 337.485 181.453 335.9 181.453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.12 182.227H311.979C310.394 182.227 309.109 183.511 309.109 185.096V188.046C309.109 189.631 310.394 190.916 311.979 190.916H335.12C336.704 190.916 337.989 189.631 337.989 188.046V185.096C337.989 183.511 336.704 182.227 335.12 182.227Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.68 187.51L331.826 187.194C332.037 187.35 332.292 187.435 332.555 187.437C332.896 187.437 333.041 187.308 333.041 187.146C333.041 186.675 331.728 186.983 331.728 186.165C331.728 185.808 332.012 185.508 332.62 185.508C332.879 185.502 333.135 185.569 333.358 185.703L333.228 186.019C333.043 185.912 332.834 185.854 332.62 185.849C332.279 185.849 332.142 185.978 332.142 186.149C332.142 186.611 333.447 186.311 333.447 187.121C333.447 187.47 333.163 187.778 332.555 187.778C332.242 187.788 331.934 187.694 331.68 187.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.276 185.88H333.547V185.531H335.419V185.88H334.682V187.744H334.268L334.276 185.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.408 249.805H31.8516V258.364H372.408V249.805Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.408 249.805H31.8516V258.364H372.408V249.805Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.2168 249.805H49.4062V258.972H50.2168V249.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.396 249.805H125.586V258.972H126.396V249.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.568 249.805H201.758V258.972H202.568V249.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.74 249.805H277.93V258.972H278.74V249.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.92 249.805H354.109V258.972H354.92V249.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.408 261.719H31.8516V265.69H372.408V261.719Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M372.408 261.719H31.8516V265.69H372.408V261.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.153 291.852H163.926C162.305 293.205 159.614 294.081 157.125 294.47C154.264 294.924 151.451 294.907 148.606 295.337C146.896 295.573 145.227 296.045 143.646 296.739C143.278 297.028 142.934 297.345 142.617 297.687C142.041 298.312 141.944 298.976 143.224 299.349C147.056 300.504 151.157 300.4 154.924 299.05C158.692 297.7 161.926 295.177 164.153 291.852Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5 298.755L140.196 300.214C139.037 300.384 138.94 299.703 139.742 299.403C141.266 299.346 144.208 298.301 144.5 298.755Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.145 291.852H163.918C162.297 293.205 159.606 294.081 157.117 294.47C154.256 294.924 151.444 294.907 148.599 295.337C146.888 295.573 145.219 296.045 143.638 296.739C143.271 297.028 142.926 297.345 142.609 297.687C142.033 298.312 141.936 298.976 143.217 299.349C147.048 300.504 151.149 300.4 154.916 299.05C158.684 297.7 161.919 295.177 164.145 291.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5 298.755L140.196 300.214C139.037 300.384 138.94 299.703 139.742 299.403C141.266 299.346 144.208 298.301 144.5 298.755Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.558 288.567C162.558 288.745 162.461 288.939 162.388 289.158C162.315 289.377 162.315 289.385 162.274 289.499C162.193 289.742 162.096 289.993 161.991 290.269L161.804 290.698C161.731 290.877 161.658 291.047 161.569 291.225C161.48 291.403 161.399 291.59 161.302 291.776C161.204 291.963 161.115 292.149 161.01 292.344C160.905 292.538 160.815 292.7 160.71 292.879C160.605 293.057 160.467 293.3 160.329 293.511L159.948 294.103C159.81 294.305 159.673 294.5 159.527 294.694C159.381 294.889 159.235 295.083 159.081 295.278C158.927 295.472 158.765 295.675 158.594 295.861C158.424 296.048 158.27 296.226 158.1 296.405C157.93 296.583 157.743 296.769 157.557 296.939C157.384 296.807 157.193 296.701 156.99 296.623C156.536 296.391 156.01 296.345 155.523 296.497C155.037 296.648 154.629 296.985 154.388 297.434C154.295 297.696 154.27 297.977 154.317 298.251C154.364 298.525 154.48 298.782 154.655 298.998C154.301 299.18 153.935 299.34 153.561 299.476L153.245 299.582L152.888 299.695C152.716 299.754 152.54 299.8 152.361 299.833C152.233 299.868 152.104 299.895 151.972 299.914C151.78 299.961 151.585 299.996 151.389 300.02L150.724 300.084C150.492 300.084 150.249 300.084 149.995 300.084C149.069 300.08 148.147 299.969 147.247 299.752C146.745 299.632 146.25 299.486 145.764 299.314C144.854 298.988 143.971 298.592 143.121 298.131C142.757 297.936 142.392 297.726 142.011 297.491C141.743 297.373 141.503 297.199 141.307 296.981C141.112 296.763 140.965 296.506 140.877 296.226C140.789 295.947 140.761 295.652 140.796 295.362C140.831 295.071 140.927 294.791 141.079 294.54C141.332 294.037 141.634 293.56 141.978 293.114C143.481 292.229 145.174 291.718 146.915 291.622C149.833 291.403 152.767 291.947 155.677 291.695C158.205 291.476 160.888 290.479 162.323 288.453L162.558 288.567Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.241 296.789L139.002 298.491C137.818 298.58 137.599 297.397 138.386 297.048C139.966 297.21 142.819 295.954 143.241 296.789Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.558 288.567C162.558 288.745 162.461 288.939 162.388 289.158C162.315 289.377 162.315 289.385 162.274 289.499C162.193 289.742 162.096 289.993 161.991 290.269L161.804 290.698C161.731 290.877 161.658 291.047 161.569 291.225C161.48 291.403 161.399 291.59 161.302 291.776C161.204 291.963 161.115 292.149 161.01 292.344C160.905 292.538 160.815 292.7 160.71 292.879C160.605 293.057 160.467 293.3 160.329 293.511L159.948 294.103C159.81 294.305 159.673 294.5 159.527 294.694C159.381 294.889 159.235 295.083 159.081 295.278C158.927 295.472 158.765 295.675 158.594 295.861C158.424 296.048 158.27 296.226 158.1 296.405C157.93 296.583 157.743 296.769 157.557 296.939C157.384 296.807 157.193 296.701 156.99 296.623C156.536 296.391 156.01 296.345 155.523 296.497C155.037 296.648 154.629 296.985 154.388 297.434C154.295 297.696 154.27 297.977 154.317 298.251C154.364 298.525 154.48 298.782 154.655 298.998C154.301 299.18 153.935 299.34 153.561 299.476L153.245 299.582L152.888 299.695C152.716 299.754 152.54 299.8 152.361 299.833C152.233 299.868 152.104 299.895 151.972 299.914C151.78 299.961 151.585 299.996 151.389 300.02L150.724 300.084C150.492 300.084 150.249 300.084 149.995 300.084C149.069 300.08 148.147 299.969 147.247 299.752C146.745 299.634 146.25 299.488 145.764 299.314C144.851 298.995 143.967 298.599 143.121 298.131C142.757 297.936 142.392 297.726 142.011 297.491C141.743 297.373 141.503 297.199 141.307 296.981C141.112 296.763 140.965 296.506 140.877 296.226C140.789 295.947 140.761 295.652 140.796 295.362C140.831 295.071 140.927 294.791 141.079 294.54C141.332 294.037 141.634 293.56 141.978 293.114C143.481 292.229 145.174 291.718 146.915 291.622C149.833 291.403 152.767 291.947 155.677 291.695C158.205 291.476 160.888 290.479 162.323 288.453L162.558 288.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.906 292.027L244.036 291.97C245.508 292.518 247.093 292.688 248.648 292.465C250.48 292.278 252.198 291.808 254.022 291.598C255.113 291.463 256.218 291.48 257.304 291.646C257.585 291.763 257.856 291.902 258.115 292.06C258.569 292.351 258.739 292.749 258.018 293.178C255.854 294.528 253.313 295.145 250.772 294.938C248.23 294.731 245.822 293.71 243.906 292.027Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.094 293.053L259.979 293.239C260.717 293.158 260.668 292.721 260.125 292.672C259.177 292.883 257.223 292.712 257.094 293.053Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.906 292.027L244.036 291.97C245.508 292.518 247.093 292.688 248.648 292.465C250.48 292.278 252.198 291.808 254.022 291.598C255.113 291.463 256.218 291.48 257.304 291.646C257.585 291.763 257.856 291.902 258.115 292.06C258.569 292.351 258.739 292.749 258.018 293.178C255.854 294.528 253.313 295.145 250.772 294.938C248.23 294.731 245.822 293.71 243.906 292.027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.094 293.045L259.979 293.231C260.717 293.15 260.668 292.713 260.125 292.664C259.177 292.875 257.223 292.705 257.094 293.045Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.719 288.8L244.857 288.727C245.456 289.272 246.163 289.684 246.933 289.937C247.703 290.19 248.517 290.277 249.323 290.194C251.179 290.096 252.986 289.497 254.842 289.383C255.948 289.29 257.061 289.465 258.085 289.894C258.337 290.144 258.567 290.415 258.774 290.704C258.89 290.85 258.974 291.018 259.021 291.199C259.067 291.379 259.075 291.568 259.044 291.751C259.012 291.935 258.942 292.11 258.839 292.265C258.735 292.42 258.599 292.551 258.441 292.65C250.757 298.98 245.618 290.996 244.719 288.8Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.609 292.289L260.43 292.994C261.184 292.946 261.241 292.184 260.689 292.03C259.709 292.265 257.804 291.73 257.609 292.289Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M244.719 288.8L244.857 288.727C245.456 289.272 246.163 289.684 246.933 289.937C247.703 290.19 248.517 290.277 249.323 290.194C251.179 290.096 252.986 289.497 254.842 289.383C255.948 289.29 257.061 289.465 258.085 289.894C258.337 290.144 258.567 290.415 258.774 290.704C258.89 290.85 258.974 291.018 259.021 291.199C259.067 291.379 259.075 291.568 259.044 291.751C259.012 291.935 258.942 292.11 258.839 292.265C258.735 292.42 258.599 292.551 258.441 292.65C250.757 298.98 245.618 290.996 244.719 288.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.014 290.249L195.884 290.192C194.405 290.69 192.824 290.804 191.288 290.524C189.473 290.273 187.787 289.714 185.971 289.479C184.898 289.313 183.808 289.291 182.729 289.414C182.45 289.522 182.18 289.649 181.918 289.795C181.456 290.071 181.27 290.452 181.975 290.914C184.077 292.323 186.576 293.019 189.104 292.899C191.632 292.779 194.054 291.85 196.014 290.249Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.853 290.806L179.976 290.896C179.246 290.782 179.311 290.352 179.854 290.328C180.786 290.563 182.74 290.474 182.853 290.806Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.006 290.249L195.876 290.192C194.397 290.69 192.816 290.804 191.281 290.524C189.465 290.273 187.779 289.714 185.963 289.479C184.89 289.313 183.8 289.291 182.721 289.414C182.443 289.522 182.172 289.649 181.911 289.795C181.449 290.071 181.262 290.452 181.967 290.914C184.069 292.323 186.569 293.019 189.096 292.899C191.624 292.779 194.046 291.85 196.006 290.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.853 290.806L179.976 290.896C179.246 290.782 179.311 290.352 179.854 290.328C180.786 290.563 182.74 290.474 182.853 290.806Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.652 287.969C195.613 287.931 195.57 287.898 195.522 287.872C194.848 288.312 194.089 288.605 193.295 288.732C192.5 288.859 191.688 288.817 190.91 288.61C189.103 288.229 187.425 287.353 185.626 286.988C184.56 286.733 183.449 286.733 182.383 286.988C182.094 287.198 181.823 287.431 181.573 287.686C181.434 287.809 181.324 287.96 181.248 288.129C181.172 288.298 181.133 288.481 181.133 288.666C181.133 288.852 181.172 289.035 181.248 289.204C181.324 289.373 181.434 289.524 181.573 289.647C188.138 297.047 194.46 289.987 195.652 287.969Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.454 289.386L179.577 289.637C178.847 289.475 178.928 288.713 179.471 288.656C180.395 289.037 182.349 288.802 182.454 289.386Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M195.652 287.969C195.613 287.931 195.57 287.898 195.522 287.872C194.848 288.312 194.089 288.605 193.295 288.732C192.5 288.859 191.688 288.817 190.91 288.61C189.103 288.229 187.425 287.353 185.626 286.988C184.56 286.733 183.449 286.733 182.383 286.988C182.094 287.198 181.823 287.431 181.573 287.686C181.434 287.809 181.324 287.96 181.248 288.129C181.172 288.298 181.133 288.481 181.133 288.666C181.133 288.852 181.172 289.035 181.248 289.204C181.324 289.373 181.434 289.524 181.573 289.647C188.138 297.047 194.46 289.987 195.652 287.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.75 297.991H287.855C288.943 297.436 290.152 297.157 291.373 297.181C292.808 297.181 294.186 297.351 295.62 297.335C296.475 297.335 297.326 297.218 298.149 296.986C298.349 296.87 298.539 296.737 298.717 296.589C299.041 296.322 299.138 296.006 298.538 295.73C296.735 294.9 294.713 294.673 292.771 295.08C290.828 295.487 289.068 296.508 287.75 297.991Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.875 295.937L300.088 295.516C300.671 295.516 300.671 295.848 300.258 295.937C299.504 295.864 298.005 296.18 297.875 295.937Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.75 297.991H287.855C288.943 297.436 290.152 297.157 291.373 297.181C292.808 297.181 294.186 297.351 295.62 297.335C296.475 297.335 297.326 297.218 298.149 296.986C298.349 296.87 298.539 296.737 298.717 296.589C299.041 296.322 299.138 296.006 298.538 295.73C296.735 294.9 294.713 294.673 292.771 295.08C290.828 295.487 289.068 296.508 287.75 297.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.867 295.945L300.08 295.523C300.664 295.523 300.664 295.856 300.25 295.945C299.496 295.872 297.997 296.188 297.867 295.945Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.719 297.734L287.832 297.79C288.298 297.365 288.849 297.043 289.448 296.846C290.048 296.649 290.682 296.581 291.309 296.648C292.76 296.729 294.163 297.191 295.605 297.288C296.468 297.358 297.335 297.222 298.134 296.891C298.332 296.692 298.514 296.478 298.677 296.25C298.768 296.137 298.834 296.006 298.87 295.865C298.906 295.724 298.912 295.578 298.888 295.434C298.863 295.291 298.809 295.155 298.728 295.034C298.647 294.914 298.541 294.812 298.418 294.735C292.42 289.799 288.408 296.015 287.719 297.734Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.758 295.004L299.954 294.461C300.538 294.461 300.57 295.093 300.157 295.207C299.395 295.02 297.904 295.425 297.758 295.004Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.719 297.734L287.832 297.79C288.298 297.365 288.849 297.043 289.448 296.846C290.048 296.649 290.682 296.581 291.309 296.648C292.76 296.729 294.163 297.191 295.605 297.288C296.468 297.358 297.335 297.222 298.134 296.891C298.332 296.692 298.514 296.478 298.677 296.25C298.768 296.137 298.834 296.006 298.87 295.865C298.906 295.724 298.912 295.578 298.888 295.434C298.863 295.291 298.809 295.155 298.728 295.034C298.647 294.914 298.541 294.812 298.418 294.735C292.42 289.799 288.408 296.015 287.719 297.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.743 294.446H120.589C119.3 293.448 117.781 292.79 116.172 292.533C114.299 292.152 112.451 292.095 110.571 291.722C109.447 291.522 108.356 291.167 107.329 290.669C107.094 290.466 106.875 290.247 106.672 290.012C106.316 289.583 106.267 289.145 107.118 288.934C109.68 288.27 112.388 288.447 114.841 289.439C117.295 290.432 119.364 292.187 120.743 294.446Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.951 289.364L105.155 288.294C104.393 288.149 104.344 288.594 104.839 288.805C105.836 288.894 107.732 289.656 107.951 289.364Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.743 294.446H120.589C119.3 293.448 117.781 292.79 116.172 292.533C114.299 292.152 112.451 292.095 110.571 291.722C109.447 291.522 108.356 291.167 107.329 290.669C107.094 290.466 106.875 290.247 106.672 290.012C106.316 289.583 106.267 289.145 107.118 288.934C109.68 288.27 112.388 288.447 114.841 289.439C117.295 290.432 119.364 292.187 120.743 294.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.951 289.364L105.155 288.294C104.393 288.149 104.344 288.594 104.839 288.805C105.836 288.894 107.732 289.656 107.951 289.364Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.855 294.122L120.693 294.163C120.18 293.498 119.532 292.948 118.792 292.55C118.051 292.152 117.236 291.915 116.398 291.853C114.485 291.61 112.531 291.853 110.61 291.666C109.456 291.558 108.344 291.175 107.368 290.548C107.153 290.245 106.968 289.922 106.817 289.583C106.724 289.414 106.668 289.227 106.653 289.035C106.637 288.843 106.663 288.649 106.728 288.468C106.794 288.286 106.897 288.12 107.031 287.981C107.165 287.843 107.327 287.734 107.506 287.662C116.568 282.605 120.361 291.707 120.855 294.122Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.335 288.169L105.579 286.937C104.769 286.848 104.623 287.618 105.133 287.869C106.179 287.812 108.027 288.712 108.335 288.169Z",
    fill: "#8F4300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.855 294.122L120.693 294.163C120.18 293.498 119.532 292.948 118.792 292.55C118.051 292.152 117.236 291.915 116.398 291.853C114.485 291.61 112.531 291.853 110.61 291.666C109.456 291.558 108.344 291.175 107.368 290.548C107.153 290.245 106.968 289.922 106.817 289.583C106.724 289.414 106.668 289.227 106.653 289.035C106.637 288.843 106.663 288.649 106.728 288.468C106.794 288.286 106.897 288.12 107.031 287.981C107.165 287.843 107.327 287.734 107.506 287.662C116.568 282.605 120.361 291.707 120.855 294.122Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAddonIcon);
export default __webpack_public_path__ + "static/media/no_addon_icon.2ddd7a16d02711f072aee332fe8aaf53.svg";
export { ForwardRef as ReactComponent };